// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Login from './Login';
import Dashboard from './Dashboard';
import Patients from './Patients';
import PatientForm from './PatientForm';
import PatientDetail from './PatientDetail';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import NewDSIAnalysisReports from './NewDSIAnalysisReports';
import ReportingRoute from './ReportingRoute';
import HelpCenter from './HelpCenter';

// 🔹 department messaging mini-portal (public)
import DepartmentMessagesPortal from './DepartmentMessagesPortal';

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Public (never calls whoami) */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        {/* 🔹 PUBLIC department messaging portal (no ProtectedRoute, no whoami) */}
        <Route path="/department-messages" element={<DepartmentMessagesPortal />} />

        {/* Protected shell */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        >
          {/* Index → Patients (so we don't bounce through /dashboard twice) */}
          <Route index element={<Navigate to="/dashboard/patients" replace />} />
          <Route path="patients" element={<Patients />} />
          <Route path="patients/new" element={<PatientForm />} />
          <Route path="patients/edit/:id" element={<PatientForm />} />
          <Route path="patients/:id/view" element={<PatientDetail />} />
          <Route path="reports/new-dsi" element={<NewDSIAnalysisReports />} />
          <Route path="reporting" element={<ReportingRoute />} />
          <Route path="help-training" element={<HelpCenter />} />
        </Route>

        {/* Root → patients directly; avoids an extra re-route */}
        <Route path="/" element={<Navigate to="/dashboard/patients" replace />} />
        <Route path="*" element={<Navigate to="/dashboard/patients" replace />} />
      </Routes>
    </Router>
  );
}
